export default {
  name: 'ScriptPackEdit',
};
